import Component from "./Support";
import { connect } from "react-redux";

export default connect(
    ({ auth: { loggedIn } }) => ({ loggedIn }),
    ({ auth: { logout } }) => ({ logout })
)(Component);


